import { QueryClient } from '@tanstack/react-query';
import { clearSignInState } from './useSilentSignIn';

/**
 * Tears down the transient post-signup session before landing on the
 * submission guide: the silent-login tokens plus every query cached
 * while signed in (pending SIM requests, skeletons, customers,
 * profiles). Leaving these around lets a later signup in the same tab
 * reuse another supplier's data — e.g. duplicate document creates.
 */
export function clearPostSignupSession(queryClient: QueryClient) {
    clearSignInState();
    queryClient.clear();
}
